var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin":"30px"}},[_c('el-button',{staticStyle:{"font-size":"14px"},attrs:{"type":"success","plain":"","icon":"el-icon-down"},on:{"click":_vm.downCommand}},[_vm._v("下载命令行工具")])],1),_c('iframe',{staticStyle:{"width":"100%","border":"none"},attrs:{"id":"iframe","src":"input/metabolome_16s-create.html"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }